import { render, staticRenderFns } from "./ModalUpdateModule.vue?vue&type=template&id=b9eed5a2&"
import script from "./ModalUpdateModule.vue?vue&type=script&lang=js&"
export * from "./ModalUpdateModule.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports